import { vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withModifiers as _withModifiers, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "select__view" }
const _hoisted_2 = { class: "select__empty" }
const _hoisted_3 = ["for"]
const _hoisted_4 = ["onChange", "checked", "disabled", "id"]
const _hoisted_5 = { class: "select-title" }
const _hoisted_6 = ["checked"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _withDirectives(_createElementVNode("span", {
      class: "select-box-trigger-area",
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggleSelect && _ctx.toggleSelect(...args)))
    }, null, 512), [
      [_vShow, _ctx.isSelectOpened]
    ]),
    _createElementVNode("div", {
      class: _normalizeClass(['select', _ctx.isSelectOpened ? 'opened' : 'closed', { disabled: _ctx.disabled }]),
      onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.toggleSelect && _ctx.toggleSelect(...args)))
    }, [
      _createElementVNode("ul", _hoisted_1, [
        _createElementVNode("li", _hoisted_2, "Selecione " + _toDisplayString(_ctx.label), 1)
      ]),
      _createElementVNode("div", {
        onClick: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["stop"])),
        class: _normalizeClass(['select__options', _ctx.isSelectOpened ? 'opened' : 'closed'])
      }, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options, (option, index) => {
          return (_openBlock(), _createElementBlock("label", {
            class: "option__label",
            key: index,
            for: _ctx.optionID(option.id)
          }, [
            _createElementVNode("input", {
              onChange: ($event: any) => (_ctx.updateModelValue(option, $event.target)),
              checked: _ctx.modelValue.map((value) => value.id).includes(option.id),
              disabled: _ctx.disabled,
              id: _ctx.optionID(option.id),
              class: "option__input",
              type: "checkbox"
            }, null, 40, _hoisted_4),
            _createElementVNode("span", _hoisted_5, _toDisplayString(option[_ctx.optionLabelAttribute]), 1)
          ], 8, _hoisted_3))
        }), 128))
      ], 2),
      (_ctx.required)
        ? (_openBlock(), _createElementBlock("input", {
            key: 0,
            tabindex: "-1",
            class: "select__input-hidden",
            type: "checkbox",
            checked: _ctx.modelValue.length
          }, null, 8, _hoisted_6))
        : _createCommentVNode("", true)
    ], 2)
  ], 64))
}